export default "__VITE_ASSET__DLm5hWrd__"